import { render, staticRenderFns } from "./indexMessageList.vue?vue&type=template&id=3e2940c1&scoped=true&name=indexMessageList&"
import script from "./indexMessageList.vue?vue&type=script&lang=js&"
export * from "./indexMessageList.vue?vue&type=script&lang=js&"
import style0 from "./indexMessageList.vue?vue&type=style&index=0&id=3e2940c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2940c1",
  null
  
)

export default component.exports